import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import queryString from "query-string";

import { LOGIN } from "../../actions/Constants";
import api from "../../api/apiUtil";
import fieldNormalize from "../../components/Normalize/FieldNormalize";

import logo from "../../img/e-registro-logo.png";
import backgroundLogin from "../../img/e-registro-new-login.jpg";
import HeaderAlias from "../../components/Layout/HeaderAlias";
import Footer from "../../components/Layout/Footer";

// Página de login exclusiva para SSO (Microsoft Entra ID), separada do login padrão (/).
// Pede apenas o CPF, descobre a financeira/método via /api/loginConfig e redireciona ao IdP.
class SsoLogin extends React.Component {
  constructor(props) {
    super(props);
    const values = queryString.parse(this.props.location.search);
    this.state = {
      cpf: "",
      opcoes: null, // lista de financeiras com SSO quando o CPF pertence a mais de uma
      loading: false,
      config: null,
      recuperouConfig: false,
      ssoError: values.ssoError,
      ssoLoginCode: values.ssoLoginCode,
    };
    this.onChangeCpf = this.onChangeCpf.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    // Carrega o template visual (logo/fundo) igual à tela de login padrão.
    Promise.resolve(api.Auth.ping()).then(() => {
      if (this.state.ssoLoginCode) {
        // O código é opaco, expira em um minuto e pode ser usado uma única vez.
        // Removê-lo imediatamente evita que permaneça no histórico do navegador.
        const ssoLoginCode = this.state.ssoLoginCode;
        window.history.replaceState(null, document.title, "/sso");
        Promise.resolve(api.Auth.consumeSsoLoginCode(ssoLoginCode))
          .then((auth) => this.props.onLogin(auth))
          .catch(() => {
            this.setState({ ssoError: "erro_sso" });
            toastr.warning("Atenção", "Não foi possível concluir o login corporativo.");
          });
      }
      Promise.resolve(api.Configuracao.getPorAtributo("template"))
        .then((res) => {
          if (res) this.setState({ config: JSON.parse(res.valor) });
          this.setState({ recuperouConfig: true });
        })
        .catch(() => this.setState({ recuperouConfig: true }));
    });
  }

  onChangeCpf(e) {
    this.setState({ cpf: fieldNormalize.CPF(e.target.value), opcoes: null });
  }

  // Redireciona ao endpoint de início do SSO no backend (mesma origem).
  redirecionaSso(opcao) {
    const rota = opcao.metodo === "saml" ? "/api/saml/login" : "/api/oidc/login";
    // origem=sso faz o backend devolver o usuário a esta tela ao final do fluxo.
    window.location.href = `${rota}?fin=${opcao.idFinanceira}&origem=sso`;
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.state.cpf) return;
    this.setState({ loading: true, opcoes: null });
    Promise.resolve(api.Auth.loginConfig(this.state.cpf))
      .then((res) => {
        this.setState({ loading: false });
        const opcoes = (res && res.opcoes) || [];
        if (opcoes.length === 0) {
          toastr.info("Login", "Este CPF não usa login corporativo. Utilize o login padrão.");
        } else if (opcoes.length === 1) {
          this.redirecionaSso(opcoes[0]);
        } else {
          this.setState({ opcoes });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        toastr.warning("Atenção", "Não foi possível verificar o acesso. Tente novamente.");
      });
  }

  render() {
    if (!this.state.recuperouConfig) {
      return null;
    }
    const { config, opcoes } = this.state;
    return (
      <>
        <HeaderAlias></HeaderAlias>
        <div
          className="login-container login-background"
          style={{ backgroundImage: `url(${config && config.img_fundo_login ? "data:image/png;base64," + config.img_fundo_login : backgroundLogin})` }}
        >
          <div className="color-line-ereg"></div>
          <div className="login-form">
            <div className="row">
              <div className="col-md-12">
                <div className="hpanel">
                  <div className="panel-body-round">
                    <div className="login-img-container">
                      <img src={config && config.logo_sistema ? `data:image/jpeg;base64,${config.logo_sistema}` : logo} />
                    </div>
                    <div className="text-center m-b-md">
                      <small>Acesso corporativo (SSO)</small>
                    </div>

                    {!opcoes ? (
                      <form id="ssoForm" onSubmit={this.onSubmit}>
                        <div className="form-group has-feedback">
                          <label>Usuário</label>
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="fa fa-user" />
                            </span>
                            <input
                              className="form-control"
                              name="cpf"
                              type="text"
                              value={this.state.cpf}
                              onChange={this.onChangeCpf}
                              placeholder="000.000.000-00"
                              title="Digite seu CPF cadastrado no sistema"
                              autoFocus
                            />
                          </div>
                        </div>
                        <button type="submit" disabled={this.state.loading} className="btn btn-alternative btn-login btn-block">
                          {this.state.loading ? "VERIFICANDO..." : "CONTINUAR"}
                        </button>
                        <Link to="/login" className="btn btn-link-blue btn-block">
                          Voltar ao login padrão
                        </Link>
                      </form>
                    ) : (
                      <div>
                        <div className="text-center mb-2">
                          <small>Selecione a financeira para continuar</small>
                        </div>
                        {opcoes.map((op) => (
                          <button key={op.idFinanceira} type="button" className="btn btn-alternative btn-login btn-block" onClick={() => this.redirecionaSso(op)}>
                            {op.razaoSocial || `Financeira ${op.idFinanceira}`}
                          </button>
                        ))}
                        <button type="button" className="btn btn-link-blue btn-block" onClick={() => this.setState({ opcoes: null })}>
                          Voltar
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {this.state.ssoError ? toastr.warning("Atenção", "Não foi possível concluir o login corporativo.") : ""}
          </div>
        </div>
        <Footer
          copyright={this.props.configLayout && this.props.configLayout.copyright ? this.props.configLayout.copyright : null}
          footer={this.props.configLayout && this.props.configLayout.footer ? this.props.configLayout.footer : null}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (payload) => dispatch({ type: LOGIN, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SsoLogin);
